import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicenseActivationsGet = {
    path: "/license/activations",
    method: ERouteHttpVerb.GET
};
export { routeLocationLicenseActivationsGet };
